/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';


class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg viewBox="0 0 55.9 64.22" width="55.9" height="64.22" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
  <path fill="#fcb61c" d="M54.65-.04a1.25 1.25 0 01.13 2.49H1.25a1.25 1.25 0 01-.13-2.49h53.53z"/>
  <path fill="#0e497b" d="M28.24 10.38a1.24 1.24 0 011.24 1.12v51.46a1.25 1.25 0 01-2.49.13V11.63a1.24 1.24 0 011.25-1.25z"/>
  <path fill="#0e497b" d="M27.72 10.33a1.27 1.27 0 011.6-.09l.11.09 23.88 22.26a1.25 1.25 0 01-1.6 1.92l-.1-.09-23.09-21.46L5.39 34.43a1.25 1.25 0 01-1.67 0l-.1-.09a1.25 1.25 0 010-1.67l.09-.1z"/>
</svg>

    );
  }
}

Icon.displayName = 'OneArrowPointingUpToHorizontalLineIcon';

export default Icon;
